<template>
  <div class="header">
    <div class="content top-header">
      <div class="verticalMiddle">
        欢迎<span
          style="
            color: #f89a00;
            margin: 0 8px;
            cursor: pointer;
            max-width: 192px;
            overflow: hidden;
          "
          @click="$router.push('/personal')"
          v-if="userName"
          >{{ name }}</span
        >来到鲜丰汇&nbsp;&nbsp;&nbsp;&nbsp;好物助农 即刻出发！
        <span
          style="color: #f89a00; margin-left: 25px; cursor: pointer"
          @click="userName ? logout() : $router.push('/login')"
          >{{ userName ? "退出" : "登录" }}</span
        >
        <!-- <span
          v-if="!userName"
          style="color: #F89A00; margin-left: 15px; cursor: pointer"
          @click="$router.push('/register')"
          >注册</span
        > -->
      </div>
      <div id="nav">
        <span @click="$router.push('/personal')">采购人中心</span>
        <!-- <span>供应商中心</span> -->
        <span class="smallHover"
          >小程序码<span class="smallImgBox"
            ><img
              src="../../../static/image/smallCode.jpg"
              alt=""
              width="100%"
              height="100%"
              class="smallImg" /></span
        ></span>
        <span @click="$router.push('/shopCar')">购物车({{ shopCarNum }})</span>
        <span @click="$router.push('/myCollection')"
          >收藏夹({{ collectNum }})</span
        >

        <span @click="$router.push('/infoCenter')">资讯中心</span>
        <span @click="visible = true" style="color: #f89a00"
          >区域专属客户经理</span
        >
        <!-- <span style="color: #f89a00; margin-left: 25px"
          >如有疑问请联系区域客服经理</span
        > -->
      </div>
    </div>
    <Dialog :dialogVisible="visible" @closepop="visible = false"></Dialog>
  </div>
</template>
<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "./dialog.vue";
export default {
  components: {
    Dialog: dialog,
  },
  data() {
    return {
      visible: false,

      userName: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").pcAccount
        : "",
      name: this.$cookies.get("userInfo")
        ? this.$cookies.get("userInfo").name
        : "",
      shopCarNum: this.$store.state.shopCarNum, //购物车数量
      collectNum: this.$store.state.collectNum, //收藏夹数量
    };
  },
  watch: {
    "$store.state.shopCarNum"() {
      this.shopCarNum = this.$store.state.shopCarNum;
    },
    "$store.state.collectNum"() {
      this.collectNum = this.$store.state.collectNum;
    },
  },
  mounted() {
    this.getShopCar(0); //获取购物车列表
    this.getShopCar(1); //获取收藏夹列表
  },
  methods: {
    /**
     * 获取购物车和收藏夹
     */
    getShopCar(type) {
      var that = this;
      doGet(
        httpConfig.shopCar.getShopCarUrl,
        { type },
        function (res) {
          if (res.flag) {
            if (type == 0) {
              that.shopCarNum = 0;
              var shopCar = res.data;
              shopCar.forEach((item) => {
                item.info = JSON.parse(item.info);
                that.shopCarNum += item.info.num; //计算购物车商品总数
              });
            } else {
              that.collectNum = res.data.length;
            }
          }
        },
        function (res) {}
      );
    },
    //退出登录
    logout() {
      var that = this;
      this.$confirm("确认退出登录？")
        .then((_) => {
          that.$cookies.remove("peopleId");
          // that.$cookies.remove("shopCar");
          // that.$cookies.remove("shopAddress");
          // that.$cookies.remove("collectList");
          that.$cookies.remove("userInfo");
          localStorage.removeItem("xfh_usertoken");
          // sessionStorage.clear();
          location.reload();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  height: 40px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 12px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #969696;
}
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
.smallHover {
  position: relative;
}
.smallHover:hover .smallImgBox {
  display: inline-block;
}
.smallImgBox {
  display: none;
  width: 200px;
  height: 200px;
  position: absolute;
  top: 40px;
  background-color: #fff;
  z-index: 100;
  left: 50%;
  transform: translate(-50%, 0);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
}
.smallImgBox::before {
  content: "";
  width: 16px;
  height: 10px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid #fff;
  box-sizing: border-box;
  border-right: 8px solid transparent;
  border-left: 8px solid transparent;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translate(-50%, 0);
}
.content {
  width: 1200px;
}
.verticalMiddle {
  margin: auto 0;
}
#nav {
  display: flex;
  height: 100%;
}

#nav > span {
  padding: 0 15px;
  cursor: pointer;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header2.vue